export default {
  scaleScore: '规模度',
  specialityScore: '专业度',
  evaluateScore: '评价度',
  audienceScore: '观众度',
  marketScore: '市场度',
  exhibitionAddress: '举办地址',
  exhibitionHall: '举办展馆',
  exhibitionArea: '展览面积',
  openingHours: '开闭馆时间',
  exhibitorsNumber: '展商数量',
  exhibitorsNumberUnit: '家',
  audienceSize: '观众数量',
  audienceSizeUnit: '人',
  cycle: '举办周期',
  boothMap: '展位　图',
  getBoothMap: '获取展位图',
  subsidy: '补贴',
  yes: '有',
  samePeriodExhibition: '同期举办',
  viewTime: '查看展会时间',
  viewMap: '查看地图',
  exhibitionHallNumber: '展馆号',
  travelReminder: '出行提醒',
  standardBooth: '标准展位',
  bareSpaceBooth: '光地展位',
  projectManagerQuotation: '项目经理报价',
  viewPrice: '查看价格',
  lastDay: '展会最后一天需在14:00前入场',
  ticketDescription: '购票须知',
  exhibitionHighlights: '展会要点',
  boothConsult: '展位咨询',
  exhibitorPeriodical: '展商/电子会刊',
  scaleRating: '规模度',
  professionalRating: '专业度',
  evaluationRating: '评价度',
  spectatorRating: '观众度',
  marketRating: '市场度',
  distance: '距离开展',
  day: '天',
  exhibitionInProgress: '开展中...',
  nexttermTimeRenew: '下届时间更新中',
  boothApply: '展位申请',
  ticketReservation: '门票预订',
  exhibitorDirectory: '展商名录',
  freeForALimitedTime: '门票限时免费',
  tourItinerary: '展团行程',
  weChatShare: '小程序分享',
  hotelReservation: '酒店预订',
  exhibitionPicture: '展会视图',
  visaProcessing: '签证办理',
  poster: '生成海报',
  view: '浏览',
  exhibitionIntroduction: '展会介绍',
  exhibitsRange: '展品范围',
  relatedExhibition: '相关展会',
  industry: '所属行业',
  organizer: '主办单位',
  exhibitorNumber: '展商数量',
  exhibitionInvitationLetter: '招展函',
  buyerData: '买家数据',
  exhibitionHall2: '展馆',
  attend: '人有兴趣参加',
  exhibitionReminder: '展会提醒',
  warmReminder: '温馨提醒',
  warmReminderContent:
    '展会举办时间和地点具有一定变更风险，请以收到的电子门票凭证为准，聚展也将为预订门票的用户提供电话、短信通知提醒，避免用户的出行损失。',
  notificationReminder: '通知提醒',
  addReminder: '添加到我的展会提醒',
  viewReminder: '查看我的提醒',
  openNotification: '开启订阅通知',
  closeNotification: '关闭订阅通知',
  changeNotice: '展会时间变动、交通信息随手查',
  professionalAudience: '专业观众门票预订',
  electronic_journal: '展商/电子会刊查看订阅',
  reserveButton: '立即预订',
  ImmediateGet: '立即获取',
  relatedHotspotRecommendation: '相关热点推荐',
  form1: {
    companyName: '请输入公司名称(必填)',
    name: '请输入联系人姓名(必填)',
    phone: '请输入联系电话(必填)',
    email: '请输入邮箱(选填)',
    remark: '请输入备注(选填)',
    submit: '提交',
    cancel: '取消'
  }
}
